<template lang="html">
  <div class="mainContainer">
    <p class="PercentageBar-span">
      {{ formattedPercentage }}%
    </p>
    <div id="mainBar" class="main bar">
      <div ref="percentage" class="percentaje bar" :style="[{ backgroundColor : anotherColor }]">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Number,
    secondColor: "",
    thirdColor: ""
  },
  data() {
    return {
      dataOne: Number,
      anotherColor: false
    };
  },
  computed: {
    formattedPercentage() {
      const amount = this.dataOne * 100;
      if (amount % 1 !== 0) {
        return amount.toFixed(2);
      } else {
        return amount;
      }
    }
  },
  watch: {
    dataOne: "printData",
    data: function(value) {
      this.dataOne = value
    }
  },
  methods: {
    printData() {
      this.$refs.percentage.style.width = this.dataOne * 100 + "%";
    }
  },
  beforeMount() {
    this.dataOne = this.data;
  },
  mounted() {
    if (this.secondColor != undefined) {
      this.anotherColor = this.secondColor;
      // this.$refs.percentage.style.backgroundColor = this.anotherColor;
    }
    if (this.thirdColor != undefined) {
      //console.log(this.thirdColor);
      this.anotherColor = this.thirdColor;
    }
  }
};
</script>

<style lang="css" scoped>
.mainContainer {
  height: 20px;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.PercentageBar-span {
  margin: 0;
  //width: 44px;
  text-align: right;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.bar {
  height: 10px;
  border-radius: 5px;
}
.main {
  position: absolute;
  left: 46px;
  background-color: #f6f6f7;
  width: calc(100% - 46px);
  top: 50%;
  transform: translateY(-50%);
}
.main .percentaje {
  position: absolute;
  background-color: #97e3d6;
  width: 0%;
}
</style>



// WEBPACK FOOTER //
// src/components/PercentageBar.vue